import moment from 'moment'
import { isFunction, isNumber, isString, isEmpty } from 'lodash'

const PARAMS_REPLACE_RX = /\[(\S*)\]/g
const PARAMS_TYPE_SLICE_RX = /!/

const FORMAT_TYPE_PARSERS = {
  $: value => (value / 100),
  time: timestamp => moment(timestamp).format('LT'),
  date: timestamp => moment(timestamp).format('dddd, MMMM d, YYYY'),
  minutes: seconds => Math.ceil(seconds / 60),
  remains: seconds => (
    moment().add(seconds, 's').fromNow(true)
  )
}

function applyFormatType (str) {
  if (!PARAMS_TYPE_SLICE_RX.test(str)) {
    return [str]
  }

  const [
    param,
    formatType
  ] = str.split(PARAMS_TYPE_SLICE_RX)

  return [
    param,
    FORMAT_TYPE_PARSERS[formatType]
  ]
}

export function format (str, params) {
  if (isEmpty(params)) {
    return str
  }

  return str.replace(PARAMS_REPLACE_RX, function (value, match) {
    const [
      param,
      formatTypeParser
    ] = applyFormatType(match)

    const providedParamValue = params[param]

    // If provided param value is valid
    if (isString(providedParamValue) || isNumber(providedParamValue)) {
      // And if provided param format type
      // Trying to parse param value
      if (isFunction(formatTypeParser)) {
        return formatTypeParser(providedParamValue)
      }

      // Param without formatting type
      // Returning provided value
      return providedParamValue
    }

    // Do not replacing if parameter not found or valid
    return value
  })
}
